import { KubernetesSecurityFormData } from './types';
import { SecuritySection } from './SecuritySection';
import { PodSecurityConstraintsSection } from './PodSecurityConstraintsSection';
import { ConstraintsSection } from './ConstraintsSection';

interface KubernetesSecurityConstraintsProps {
  formData: KubernetesSecurityFormData;
  onChange: <K extends keyof KubernetesSecurityFormData>(
    key: K,
    value: KubernetesSecurityFormData[K]
  ) => void;
}

export function KubernetesSecurityInnerForm({
  formData,
  onChange,
}: KubernetesSecurityConstraintsProps) {
  return (
    <>
      <SecuritySection formData={formData} onChange={onChange} />

      <PodSecurityConstraintsSection formData={formData} onChange={onChange} />

      {formData.enablePodSecurityConstraints && (
        <ConstraintsSection formData={formData} onChange={onChange} />
      )}
    </>
  );
}
